import type { AddonWebModule } from './types';

/** Import `@<app>/<addon>/web` modules here. Empty until the app ships an addon. */
export const addonWeb: AddonWebModule[] = [];
